<template>
  <!-- non-blocking top progress bar (replaces the old full-screen overlay); pages render immediately and
       show their own skeletons for API-driven parts -->
  <div class="top-progress" :class="{ active: loading }" role="progressbar" aria-hidden="true">
    <div class="top-progress__bar" />
  </div>
</template>

<script>
export default {
  name: 'LoadingPage',
  data() {
    return { loading: false }
  },
}
</script>

<style scoped>
.top-progress { position: fixed; top: 0; right: 0; left: 0; z-index: 2000; height: 3px; pointer-events: none; opacity: 0; transition: opacity .3s .1s; overflow: hidden; }
.top-progress.active { opacity: 1; transition-delay: .15s; }
.top-progress__bar { height: 100%; width: 40%; background: var(--accent, #2563eb); border-radius: 0 2px 2px 0; animation: tp-slide 1.1s ease-in-out infinite; }
@keyframes tp-slide { 0% { transform: translateX(260%); } 100% { transform: translateX(-120%); } }
@media (prefers-reduced-motion: reduce) { .top-progress__bar { animation: none; width: 100%; opacity: .6; } }
</style>
